import { render } from "./WebHand.vue?vue&type=template&id=9588bcd2&scoped=true"
import script from "./WebHand.vue?vue&type=script&lang=js"
export * from "./WebHand.vue?vue&type=script&lang=js"

import "./WebHand.vue?vue&type=style&index=0&id=9588bcd2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9588bcd2"]])

export default __exports__